import type React from 'react';
import PriceMyRentalAppAdapter from './appAdapter';
import PriceMyRentalWidget from './widget';

// types
import type { RootState } from '../flux/reducers';
import type { GoogleMapsApiKeyType, ScreenWidthType } from '../models/Types';
import type { SetFilter } from '../flux/reducers/setFilter';
interface CompsAndAddressAPIParams {
  street: string;
  unit?: string;
  city: string;
  state: string;
  zip: string;
}

export type PropsWithAPIParams = CompsAndAddressAPIParams & {
  heading?: React.ReactNode;
  screenWidth: ScreenWidthType;
  isMobile: boolean;
  googleMapsApiKey: GoogleMapsApiKeyType;
};

export type PropsWithState = RootState & {
  heading?: React.ReactNode;
  setFilter: SetFilter;
};

export type PriceMyRentalPropsType = PropsWithAPIParams | PropsWithState;

const PriceMyRental: React.FunctionComponent<
  React.PropsWithChildren<React.PropsWithChildren<PriceMyRentalPropsType>>
> = (props) => {
  if ('comparables' in props) {
    // adapter that syncs PropsWithState with component state
    return <PriceMyRentalAppAdapter {...props} />;
  }
  // standalone widget capable of API calls, etc.
  return <PriceMyRentalWidget {...props} />;
};

export default PriceMyRental;
